import { default as indexMUmX8mAfjNMeta } from "/opt/build/repo/src/pages/index.vue?macro=true";
import { default as loginwV8UxyWAwuMeta } from "/opt/build/repo/src/pages/login.vue?macro=true";
import { default as _91id_93xQxEihs5ElMeta } from "/opt/build/repo/src/pages/movie/[id].vue?macro=true";
export default [
  {
    name: indexMUmX8mAfjNMeta?.name ?? "index",
    path: indexMUmX8mAfjNMeta?.path ?? "/",
    meta: indexMUmX8mAfjNMeta || {},
    alias: indexMUmX8mAfjNMeta?.alias || [],
    redirect: indexMUmX8mAfjNMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: loginwV8UxyWAwuMeta?.name ?? "login",
    path: loginwV8UxyWAwuMeta?.path ?? "/login",
    meta: loginwV8UxyWAwuMeta || {},
    alias: loginwV8UxyWAwuMeta?.alias || [],
    redirect: loginwV8UxyWAwuMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/login.vue").then(m => m.default || m)
  },
  {
    name: _91id_93xQxEihs5ElMeta?.name ?? "movie-id",
    path: _91id_93xQxEihs5ElMeta?.path ?? "/movie/:id()",
    meta: _91id_93xQxEihs5ElMeta || {},
    alias: _91id_93xQxEihs5ElMeta?.alias || [],
    redirect: _91id_93xQxEihs5ElMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/movie/[id].vue").then(m => m.default || m)
  }
]